// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__3KD4i","label":"SetPasswdForm_label__6G-az"};